import { FC, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import { usePageContext } from "@ryde/redux";
import { activeViewSF } from "@ryde/shared";

import { MuiButton } from "../../controls";
import { ViewContext } from "../view.context";

export const SaveViewButton: FC = () => {
  const { t } = useTranslation();
  const { entity } = usePageContext();
  const activeView = useRecoilValue(activeViewSF(entity));
  const { openEditView } = useContext(ViewContext);

  const onClickHandler = (): void => {
    openEditView();
  };

  return (
    <MuiButton
      title={activeView?.name || t("view.create")}
      e2eData="save-view-button"
      muiVariant="outlined"
      muiStyle={"secondary"}
      onClick={onClickHandler}
      sx={{ flexShrink: 0, width: "107px" }}
    >
      {t(`view.create`)}
    </MuiButton>
  );
};
